import type { FC } from 'react';
import classNames from 'classnames';
import { NavLink, useLocation, useSearchParams } from 'react-router-dom';
import { useLocale, useTranslations } from 'use-intl';

import { objectToQueryString } from '@loyalty-system/shared-universal';

type SubMenuBannersProps = {
  type: 'dropdown' | 'list';
  onNavigate?: () => void;
};

const SubMenuBanners: FC<SubMenuBannersProps> = ({ type, onNavigate }) => {
  const t = useTranslations();
  const [searchParams] = useSearchParams();
  const { pathname } = useLocation();
  const locale = useLocale();

  const handleClick = () => {
    onNavigate?.();
  };

  const className = type === 'list' ? 'px-10' : '';

  return (
    <div>
      <NavLink
        to={{
          pathname: `/${locale}/banners/new`,
          search: `?${objectToQueryString({ sidebar: searchParams.get('sidebar') })}`,
        }}
        className={classNames(
          'flex items-center rounded p-2 transition-colors',
          type === 'dropdown' && 'hover:bg-accent',
          type === 'dropdown' && pathname.includes(`/${locale}/banners/new`) && '!bg-primary !text-white',
          type === 'list' && pathname.includes(`/${locale}/banners/new`) && '!text-primary',
        )}
        onClick={handleClick}
      >
        <p className={classNames('whitespace-nowrap', className)}>{t('sidebar_menu_banners_create_new')}</p>
      </NavLink>
    </div>
  );
};

export default SubMenuBanners;
